import {viewChannelLineup} from 'src/pages/localChannelLineup/constants/channelTrackingActionMap/viewChannelLineup';

export const channelTrackingActionMap = {
  ...viewChannelLineup,
};
